import api from '../../Services/api';
import jwt_decode from "jwt-decode";
import * as types from '../actionTypes';
import * as config from '../../Config/api.js';
import { Navigate } from 'react-router-dom';
import { isAbortError } from '../../Services/abortError';
import logger from '../../Services/logger';
import { breadcrumb } from '../../Services/sentry';

import moment, { lang } from 'moment-business-days';
import authStorage from '../../Services/authStorage';
	

export const setSearchType = (obj) => {
    return {
        type: types.SET_SEARCHTYPE,
        payload: obj
    }
};

export const setSearchParams = (obj) => {
    return {
        type: types.SET_SEARCHPARAMS,
        payload: obj
    }
};

/**
 * Metadados da busca devolvidos pelo backend (BUG-004).
 *
 * Hoje carrega `checkInMinimo`: a primeira data de chegada em que ainda dá para reservar, dada a
 * margem do prazo de cancelamento. Vem de lá porque a conta usa a margem, as horas residuais e o
 * calendário de feriados — três peças que moram no servidor.
 *
 * Use `checkInMinimo` (não `checkInMinimoAgora`) em qualquer coisa que o operador leia: o "agora"
 * pode virar no meio do expediente e a mensagem passaria a se contradizer no fim da tarde.
 */
export const setSearchMeta = (obj) => {
    return {
        type: types.SET_SEARCHMETA,
        payload: obj
    }
};

export const setSearchFilters = (obj) => {
    return {
        type: types.SET_SEARCHFILTERS,
        payload: obj
    }
};

export const setAppliedSearchFilters = (obj) => {
    return {
        type: types.SET_APPLIEDSEARCHFILTERS,
        payload: obj
    }
};

export const setSearchCurrency = (obj) => {
    return {
        type: types.SET_SEARCHCURRENCY,
        payload: obj
    }
};

export const setExchangeRates = (obj) => {
    return {
        type: types.SET_EXCHANGERATES,
        payload: obj
    }
};

export const setSearchResStatus = (obj) => {
    return {
        type: types.SET_SEARCHRESSTATUS,
        payload: obj
    }
};

export const setSearchResRowsNumber = (obj) => {
    return {
        type: types.SET_SEARCHRESROWSNUMBER,
        payload: obj
    }
};

export const setSearchResToken = (obj) => {

    return {
        type: types.SET_SEARCHRESTOKEN,
        payload: obj
    }
};

export const setSearchResCurrentPage = (obj) => {
    return {
        type: types.SET_SEARCHRESCURRENTPAGE,
        payload: obj
    }
};

export const setSearchResLimit = (obj) => {
    return {
        type: types.SET_SEARCHRESLIMIT,
        payload: obj
    }
};

export const setSearchLocation = (obj) => {
    return {
        type: types.SET_SEARCHLOCATION,
        payload: obj
    }
};

export const setSearchResObject = (obj) => {
    return {
        type: types.SET_SEARCHRESOBJECT,
        payload: obj
    }
};

export const setSelectedProperty = (obj) => {
	return {
		type: types.SET_SELECTEDPROPERTY,
		payload: obj
	}
};

export const setCurrentBooking = (obj) => {
	return {
		type: types.SET_CURRENTBOOKING,
		payload: obj
	}
};

export const setPaymentConfirmed = (obj) => {
	return {
		type: types.SET_PAYMENTCONFIRMED,
		payload: obj
	}
};

export const setPaymentTransaction = (obj) => {
	return {
		type: types.SET_PAYMENTTRANSACTION,
		payload: obj
	}
};

export const retrieveNavigationContinents = (data, props) => {
    return dispatch => {
        var result = localStorage.getItem("@dream4/userData", undefined, true);
        var userObj = JSON.parse(result);
        
        api({
            url: config.API_URL + '/api/v1/order/navigation/retrieveContinents',
            method: 'POST',
            data: {},
            headers: {
                "x-access-token": userObj?.userToken,
                Accept: 'application/json'
            }
        })
        .then(response => {
            if (response.data.notFound || !response.data.success) {
                props.setRows([]);
                return;
            }

            props.setRows(response.data.data);
        })
        .catch(error => {
            logger.error('[retrieveNavigationContinents] ERRO:', error);
            props.setRows([]);
        });
    };
};

export const retrieveNavigationCountries = (data, props) => {
    return dispatch => {
        // Recupera o usuário e token do localStorage
        const result = localStorage.getItem("@dream4/userData", undefined, true);
        const userObj = JSON.parse(result);

        const preparedData = {
            continentId: data.continentId
        };

        api({
            url: config.API_URL + '/api/v1/order/navigation/retrieveCountries',
            method: 'POST',
            data: preparedData,
            headers: {
                "x-access-token": userObj?.userToken,
                Accept: 'application/json'
            }
        })
        .then(response => {
            if (response.data?.success) {
                props.setRows(response.data.data);
            } else {
                props.setRows([]);
            }
        })
        .catch(error => {
            logger.error('[retrieveNavigationCountries] ERRO:', error);
            props.setRows([]);
        });
    };
};

export const retrieveNavigationCities = (data, props) => {
    return dispatch => {
        const result = localStorage.getItem("@dream4/userData", undefined, true);
        const userObj = JSON.parse(result);

        const preparedData = {
            countryId: data.countryId
        };

        api({
            url: config.API_URL + '/api/v1/order/navigation/retrieveCities',
            method: 'POST',
            data: preparedData,
            headers: {
                "x-access-token": userObj?.userToken,
                Accept: 'application/json'
            }
        })
        .then(response => {
            if (response.data?.success) {
                props.setRows(response.data.data);
            } else {
                props.setRows([]);
            }
        })
        .catch(error => {
            logger.error('[retrieveNavigationCities] ERRO:', error);
            props.setRows([]);
        });
    };
};


// Retrieve all reservations
export const retrieveDropdownCountries  = (data,props) => { 
		
	return dispatch => {
		
				// Check if there is a local USER OBEJECt with a TOKEN
				var result = localStorage.getItem("@dream4/userData", undefined,true);
				var userObj = JSON.parse(result);  
				
							
				// Set general data
				const preparedData = {};
				preparedData.keyword =  data.keyword;				
				
				// Connect to Endpoint
				api({
					   url    : config.API_URL+'/api/v1/order/dropdown/retrieveCountries',
					   method : 'POST',
					   data   : preparedData,
					   headers: {
							"x-access-token": userObj?.userToken,
							Accept: 'application/json'
						}
				})							
				
				.then((response) => {

					// Document already registered
					if (response.data.notFound) {
						
						props.setRows([]);
						return;
						
					} // end if

					if (response.data.success) {
						
						// Set list
						props.setRows(response.data.data);				
						return;
				
						
					} // end if
					else {
						
						props.setRows([]);																				
						return;
						
					} // end else
					
				})
				.catch(error=> {
					
					props.setRows([]);						
					return;
				});
				
} // end dispatch

};


export const retrieveDropdownCities  = (data,props) => { 
		
	return dispatch => {
		
				// Check if there is a local USER OBEJECt with a TOKEN
				var result = localStorage.getItem("@dream4/userData", undefined,true);
				var userObj = JSON.parse(result);  
							
				// Set general data
				const preparedData = {};
				preparedData.keyword =  data.keyword;				
				preparedData.countryCode =  data.countryCode;
				
				// Connect to Endpoint
				api({
					   url    : config.API_URL+'/api/v1/order/dropdown/retrieveCities',
					   method : 'POST',
					   data   : preparedData,
					   headers: {
							"x-access-token": userObj?.userToken,
							Accept: 'application/json'
						}
				})							
				
				.then((response) => {

					// Document already registered
					if (response.data.notFound) {
						
						props.setRows([]);
						return;
						
					} // end if

					if (response.data.success) {
						
						// Set list
						props.setRows(response.data.data);				
						return;
				
						
					} // end if
					else {
						
						props.setRows([]);																				
						return;
						
					} // end else
					
				})
				.catch(error=> {
					
					props.setRows([]);						
					return;
				});
				
} // end dispatch

};

export const retrieveDropdownProperties  = (data,props) => { 
		
	return dispatch => {
		
				// Check if there is a local USER OBEJECt with a TOKEN
				var result = localStorage.getItem("@dream4/userData", undefined,true);
				var userObj = JSON.parse(result);  

							
				// Set general data
				const preparedData = {};
				preparedData.keyword =  data.keyword;				
				
				// Connect to Endpoint
				api({
					   url    : config.API_URL+'/api/v1/order/dropdown/retrieveProperties',
					   method : 'POST',
					   data   : preparedData,
					   headers: {
							"x-access-token": userObj?.userToken,
							Accept: 'application/json'
						}
				})							
				
				.then((response) => {

					// Document already registered
					if (response.data.notFound) {
						
						props.setRows([]);
						return;
						
					} // end if

					if (response.data.success) {
						
						// Set list
						props.setRows(response.data.data);				
						return;
				
						
					} // end if
					else {
						
						props.setRows([]);																				
						return;
						
					} // end else
					
				})
				.catch(error=> {
					
					props.setRows([]);						
					return;
				});
				
} // end dispatch

};


// Create search and return and store search token id for reference
export const processLocalitySearch  = (data,props,options = {}) => {

	return async (dispatch, getState) => {

		breadcrumb('search', 'processLocalitySearch start', {
			country: data?.country?.name,
			city: data?.city?.name,
			rooms: data?.rooms?.length,
			days: data?.dateRangeDays,
		});

		try {

				// Check if there is a local USER OBEJECt with a TOKEN
				var result = localStorage.getItem("@dream4/userData", undefined,true);
				var userObj = JSON.parse(result);
			
						
				// Set general data
				const preparedData = {};
				preparedData.country =  data.country;		
				preparedData.city =  data.city;		
				preparedData.dateRange =  data.dateRange;		
				preparedData.dateRangeDays =  data.dateRangeDays;		
				preparedData.rooms =  data.rooms;		

				// set original room array to avoid obj change
				let originalRooms = [];
				for (let i = 0; i < data.rooms.length; i++) {
					let obj = {
						adults:data.rooms[i].adults,
						children:data.rooms[i].children
					}
					originalRooms.push(obj);
				}
				data.originalRooms = originalRooms;
				
				// Connect to Endpoint
				api({
					   url    : config.API_URL+'/api/v1/order/properties/search/create',
					   method : 'POST',
					   data   : preparedData,
					   signal : options.signal,
					   headers: {
							"x-access-token": userObj?.userToken,
							Accept: 'application/json'
						}
				})

				.then((response) => {

					//logger.debug('RESPONSE >>>>>> '+JSON.stringify(response.data,null,2));

					// Document already registered
					if (response.data.notFound) {

						props.handleTimeout('cancel');

						// For interface feedback
						props.setLoadingResults(false);

						props.setAlertTitle("Nenhuma propriedade encontrada!");
						props.setAlertBody("Não encontramos nenhuma propriedade disponível com as informações fornecidas. Verifique as datas e quartos e tente novamente.");
						props.setAlert(true);

						return;

					} // end if
 
					if (response.data.success) {

						// Cancel timer
						props.handleTimeout('cancel');

						dispatch(setSearchResToken(response.data.searchResultToken));
						dispatch(setSearchResRowsNumber(response.data.searchResultRowsNumber));
						dispatch(setSearchType("location"));

						// Set search result filters for interface
						dispatch(setSearchFilters(response.data.interfaceFilters.searchFilter));

						// Set search currency for result interface
						dispatch(setSearchCurrency(response.data.currency));

						// Set exchange rates
						dispatch(setExchangeRates(response.data.exchangeRates));

						// set search location
						let location = {
							continent:data.country.continentName,
							country:data.country,
							city:data.city
						} 
						dispatch(setSearchLocation(location));
						dispatch(setSearchParams(data));
						// BUG-004: primeira data reservável, calculada pelo backend. Ausente em payload
						// anterior a 14/08 — a tela trata a falta exibindo o aviso sem citar data.
						dispatch(setSearchMeta(response.data.searchMeta));

						props.setCounterStatus(true); // Stop counter

						// For interface feedback
						setTimeout(function() {
							props.setLoadingResults(false); 

							if (data.screen == 'searchResult') {
								props.executeRetrieveSearchResult(1,'review_rating',[],0,response.data.searchResultToken); // reset all controls
							} else {
								props.navigate("/order/hotel/searchResult");	
							}
													
						},1000);						
							
						return;
				
						
					} // end if
					else {
						
						// Cancel timer
						props.handleTimeout('cancel');

						// For interface feedback
						setTimeout(function() {
							props.setLoadingResults(false);
						},2000)						

						props.setAlertTitle("Ops! Ocorreu um erro!");
						props.setAlertBody("Ocorreu um erro ao realizar a busca com os dados informados. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [Order 1]");
						props.setAlert(true);																		
						return;
						
					} // end else
					
				})
				.catch(error=> {
					// Cancelamento via AbortController: ignora, NÃO toca em UI
					if (isAbortError(error)) return;

					// Cancel timer
					props.handleTimeout('cancel');

						// For interface feedback
						setTimeout(function() {
							props.setLoadingResults(false);
						},2000)

					props.setAlertTitle("Ops! Ocorreu um erro!");
					props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [Order 2]");
					props.setAlert(true);

					return;
				});

			} catch (error) {
				logger.error('Error fetching locality search:', error);

				// Cancel timer
				props.handleTimeout('cancel');

				dispatch(setSearchResToken(null));
				dispatch(setSearchResRowsNumber(0));

				props.setAlertTitle("Ops! Ocorreu um erro!");
				props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [Order 3]");
				props.setAlert(true);
				return;
			}

	} // end dispatch

};

export const retrieveSearchResult  = (data,props,options = {}) => {

	return async (dispatch, getState) => {

		breadcrumb('search', 'retrieveSearchResult (poll)', {
			page: data?.page,
			sortBy: data?.sortBy,
			hasFilter: !!data?.filterBy,
		});

		try {

				// Check if there is a local USER OBEJECt with a TOKEN
				var result = localStorage.getItem("@dream4/userData", undefined,true);
				var userObj = JSON.parse(result);
											
				// Set general data
				const preparedData = {};
				preparedData.searchResultToken =  data.searchResultToken;
				preparedData.page =  data.page;
				preparedData.sortBy =  data.sortBy;
				preparedData.filterBy =  data.filterBy;

				// Set applied search filters
				dispatch(setAppliedSearchFilters(data.filterBy));
				
				// Connect to Endpoint
				api({
					   url    : config.API_URL+'/api/v1/order/properties/search/retrieve',
					   method : 'POST',
					   data   : preparedData,
					   signal : options.signal,
					   headers: {
							"x-access-token": userObj?.userToken,
							Accept: 'application/json'
						}
				})

				.then((response) => {

					// logger.debug('RESPONSE >>>>>> '+JSON.stringify(response.data,null,2));

					// Document already registered
					if (response.data?.noToken == true) {
						
						props.setContentLoading(false);
						props.setLoadingResults(false);
						
						props.setAlertExpire(true);
						props.setAlertTitleExpire("O resultado da busca expirou");
						props.setAlertBodyExpire("O resultado da busca expirou. Faça uma nova pesquisa, para ver preços e hospedagens atualizados.");
						props.setAlertActionExpire("restartSearch");

						return;
						
					} // end if

					// Document already registered
					if (response.data?.notFound) {
						
						//dispatch(setSearchResToken(response.data.data.searchResultToken));
						dispatch(setSearchResRowsNumber(response.data.filterResultRowsNumber));
						
						props.setNotFound(true);

						props.setContentLoading(false);
						props.setLoadingResults(false);

						return;
						
					} // end if					

					if (response.data.success) {

						//dispatch(setSearchResToken(response.data.data.searchResultToken));
						dispatch(setSearchResRowsNumber(response.data.filterResultRowsNumber));
						//dispatch(setSearchType("location"));

						props.setContentLoading(false);
						props.setLoadingResults(false);

						props.setNotFound(false);

						const newResults = response.data.data.results;
						//props.setResultsCards((prevResults) => [...prevResults, ...newResults]);

						props.setResultsCards((prevResults) => {
							// Concatena os itens antigos com os novos
							const allResults = [...prevResults, ...newResults];
						
							// Filtra para remover itens duplicados com base no "id"
							const uniqueResults = allResults.filter((item, index, self) => 
							  index === self.findIndex((t) => t._id === item._id)
							);

							// set current paginated results
							props.setPaginatedResults(uniqueResults.length);

							if (typeof props.loadInterfaceElements == 'function') props.loadInterfaceElements();
						
							return uniqueResults;
						});						

						// For interface feedback
						//setTimeout(function() {
							//props.setLoadingResults(false);
							//props.navigate("/order/hotel/searchResult");							
						//},2000);						
							
						return;
				
						
					} // end if
					else {
						
						props.setContentLoading(false);
						props.setLoadingResults(false);

						// For interface feedback
						setTimeout(function() {
						//	props.setLoadingResults(false);
						},2000);						

						props.setAlertTitle("Ops! Ocorreu um erro!");
						props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [1]");
						props.setAlert(true);																		
						return;
						
					} // end else
					
				})
				.catch(error=> {
					// Cancelamento via AbortController: ignora, NÃO toca em UI
					if (isAbortError(error)) return;

					logger.debug('ERRO CATCH >>>>>>>>>> '+JSON.stringify(error.message,null,2));

					props.setContentLoading(false);
					props.setLoadingResults(false);

						// For interface feedback
						setTimeout(function() {
						//	props.setLoadingResults(false);
						},2000)

					props.setAlertTitle("Ops! Ocorreu um erro!");
					props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [2]");
					props.setAlert(true);

					return;
				});

			} catch (error) {

				props.setContentLoading(false);
				props.setLoadingResults(false);

				logger.error('Error fetching locality search:', error);
				props.setAlertTitle("Ops! Ocorreu um erro!");
				props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [3]");
				props.setAlert(true);	
				return;				
			}				
	
	} // end dispatch

};

export const retrievePropertySearchResult  = (data,props,options = {}) => {

	return async (dispatch, getState) => {

		breadcrumb('hotel', 'retrievePropertySearchResult (open hotel detail)', {
			propertyId: data?.propertyId,
			hasFilter: !!data?.filters,
		});

		try {

				// Check if there is a local USER OBEJECt with a TOKEN
				var result = localStorage.getItem("@dream4/userData", undefined,true);
				var userObj = JSON.parse(result);
				
							
				// Set general data
				const preparedData = {};
				preparedData.searchResultToken =  data.searchResultToken;
				preparedData.propertyId =  data.propertyId;
				preparedData.filters =  data.filters;
				
				// Connect to Endpoint
				api({
					   url    : config.API_URL+'/api/v1/order/property/retrieve',
					   method : 'POST',
					   data   : preparedData,
					   signal : options.signal,
					   headers: {
							"x-access-token": userObj?.userToken,
							Accept: 'application/json'
						}
				})							
				
				.then((response) => {

					// logger.debug('RESPONSE >>>>>> '+JSON.stringify(response.data,null,2));

					// Document already registered
					if (response.data?.noToken == true || response.data?.notFound) {
						
						props.setContentLoading(false);
						props.setLoadingResults(false);
						
						props.setAlertExpire(true);
						props.setAlertTitleExpire("O resultado da busca expirou");
						props.setAlertBodyExpire("O resultado da busca expirou. Faça uma nova pesquisa, para ver preços e hospedagens atualizados.");
						props.setAlertActionExpire("restartSearch");

						return;
						
					} // end if
			
					if (response.data.success) {

						props.setContentLoading(false);
						props.setLoadingResults(false);

						const propertyRes = response.data.data;
						const roomsRes = response.data.rooms;
						const poisRes = response.data.pois;
						const noRooms = (roomsRes?.length == 0 || response.data?.noRooms == true);

						// Sempre popular o "chrome" da tela (fotos, descrição, amenidades,
						// POIs) — antes este bloco era pulado quando rooms vinha vazio e a
						// tela ficava em branco mesmo com o backend tendo retornado dados
						// completos do hotel. Bug fix 2026-06-07.
						props.setResultCard(propertyRes);
						props.setResultsRooms(roomsRes || []);
						props.setResultsPois(poisRes || []);
						props.setImages(propertyRes?.photos ? propertyRes.photos : []);

						if (noRooms) {
							// Filtros limpos + data revertida para o usuário poder tentar de novo
							// num estado consistente. A tela aparece preenchida em volta do alerta.
							props.setSearchFilters(null);
							props.revertToPreviousDate();
							props.loadInterfaceElements(null);

							props.setAlert(true);
							props.setAlertTitle("Não há quartos disponíveis!");

							let alertMessage = (<><p>Não há quartos disponíveis <strong>para a data / hóspedes selecionados</strong>.</p> <p>Altere a data ou quantidade de hóspedes e tente novamente. Caso o problema persista, busque outra opção de hotel ou entre em contato com o suporte.</p></>);
							props.setAlertBody(alertMessage);
							return;
						}

						props.setSearchFilters(data.filters);

						// Set searchFilter
						props.loadInterfaceElements(data.filters);
						
						// For interface feedback
						//setTimeout(function() {
							//props.setLoadingResults(false);
							//props.navigate("/order/hotel/searchResult");							
						//},2000);						
							
						return;
				
						
					} // end if
					else {
						
						props.setContentLoading(false);
						props.setLoadingResults(false);

						// For interface feedback
						/*setTimeout(function() {
						//	props.setLoadingResults(false);
						},2000);*/						

						props.setAlertTitle("Ops! Ocorreu um erro!");
						props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [1]");
						props.setAlert(true);																		
						return;
						
					} // end else
					
				})
				.catch(error=> {
					// Cancelamento via AbortController: ignora, NÃO toca em UI
					if (isAbortError(error)) return;

					logger.debug('ERRO CATCH >>>>>>>>>> '+JSON.stringify(error.message,null,2));

					props.setContentLoading(false);
					props.setLoadingResults(false);

						// For interface feedback
						setTimeout(function() {
						//	props.setLoadingResults(false);
						},2000)

					props.setAlertTitle("Ops! Ocorreu um erro!");
					props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [2]");
					props.setAlert(true);

					return;
				});

			} catch (error) {

				props.setContentLoading(false);
				props.setLoadingResults(false);

				logger.error('Error fetching locality search:', error);
				props.setAlertTitle("Ops! Ocorreu um erro!");
				props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [3]");
				props.setAlert(true);	
				return;				
			}				
	
	} // end dispatch

};


export const retrievePropertyPriceAndAvailability  = (data,props,options = {}) => {

	return async (dispatch, getState) => {

		breadcrumb('hotel', 'retrievePropertyPriceAndAvailability (pick room)', {
			propertyId: data?.propertyId,
			roomId: data?.roomId,
			ratePlanCode: data?.ratePlanCode,
		});

		try {

				// Check if there is a local USER OBEJECt with a TOKEN
				var result = localStorage.getItem("@dream4/userData", undefined,true);
				var userObj = JSON.parse(result);

				// Set general data
				const preparedData = {};
				preparedData.searchResultToken =  data.searchResultToken;
				preparedData.propertyId =  data.propertyId;
				preparedData.searchRooms =  data.searchRooms;
				preparedData.roomId =  data.roomId;
				preparedData.ratePlanCode =  data.ratePlanCode;
				preparedData.filters =  data.filters;

//				logger.debug('preparedData --------------> '+JSON.stringify(preparedData,null,2));

				// Connect to Endpoint
				api({
					   url    : config.API_URL+'/api/v1/order/property/room/retrieve',
					   method : 'POST',
					   data   : preparedData,
					   signal : options.signal,
					   headers: {
							"x-access-token": userObj?.userToken,
							Accept: 'application/json'
						}
				})							
				
				.then((response) => {

					// logger.debug('RESPONSE >>>>>> '+JSON.stringify(response.data,null,2));

					// Document already registered
					if (response.data?.noToken == true) {
											
						props.setAlertExpire(true);
						props.setAlertTitleExpire("O resultado da busca expirou");
						props.setAlertBodyExpire("O resultado da busca expirou. Faça uma nova pesquisa, para ver preços e hospedagens atualizados.");
						props.setAlertActionExpire("restartSearch");
						return;
						
					} // end if
			
					if (response.data.success) {

						// set button loading off
						props.setPickingRoomLoading(prevState => ({
							...prevState,
							[data.objKey]: false 
						}));

						const propertyRes = response.data.data;
						const roomsRes = response.data.rooms;
						let dataJson = response.data;

						//logger.debug('<<<<<<<<<<<<<<<<<<<<<< roomsRes >>>>>>>>>>>>>>>>>>>>>>>>>>>'+JSON.stringify(roomsRes,null,2));

						let newItem = data.item;
						newItem.updatedPriceWithMarkup = Array.isArray(roomsRes) && roomsRes.length > 0 ? roomsRes[0].totalWithMarkup ?? null : null;
						
						if (!newItem.updatedPriceWithMarkup) {

							props.setAlert(true);
							props.setAlertTitle("Ops! Não foi possível adicionar o quarto.");
							//props.setAlertBody("Ocorreu um problema ao buscar as informações maiss atualizadas do quarto selecionado. É possível que o quarto não esteja mais disponível ou não comporte a configuração de hóspedes que definiu.  Tente novamente ou altere a configuração de hospedes, e caso o problema persista, selecione outro quarto ou entre em contato com o suporte.");

							let message = (<>
								<p>Não foi possível inserir o quarto selecionado.</p>
								<p>Possíveis causas:</p>
								<ul>
									<li>É possível que o quarto não esteja disponível nesse momento.</li>
									<li>É possível que o quarto não comporte a quantidade de hóspedes que definiu.</li>
									<li>É possível que tenha ocorrido algum problema de conectividade.</li>
								</ul>
								<p>
								  Tente novamente e se o problema persistir altere a configuração de datas e/ou hóspedes. Se ainda assim  o problema persistir,
								  selecione outro quarto ou entre em contato com o suporte.
								</p>
							  </>);
							props.setAlertBody(message);

							return;							

						} else {
							props.pickRoom(newItem,data.index);
							return;
						}
						
					} // end if
					else {						
						logger.debug('ERRO RETORNO >>>>>>>>>> ');																	
						return;						
					} // end else
					
				})
				.catch(error=> {
					// Libera o loading do botão DESTE quarto independente do
					// motivo (sucesso, falha real, ou cancel via AbortController
					// quando o usuário clica em outro quarto). Sem isto, ao
					// cancelar o botão antigo ficaria preso em loading.
					if (data?.objKey != null) {
						props.setPickingRoomLoading?.((prev) => ({ ...prev, [data.objKey]: false }));
					}
					if (isAbortError(error)) return;
					logger.debug('ERRO CATCH 1 >>>>>>>>>> '+JSON.stringify(error.message,null,2));
					return null;
				});

			} catch (error) {
				logger.debug('ERRO CATCH 2 >>>>>>>>>> '+JSON.stringify(error.message,null,2));
				return null;
			}

	} // end dispatch

};


export const checkSearchResult  = (data,props) => {
	
	return async (dispatch, getState) => {
		
		try {

				// Check if there is a local USER OBEJECt with a TOKEN
				var result = localStorage.getItem("@dream4/userData", undefined,true);
				var userObj = JSON.parse(result);  
				
							
				// Set general data
				const preparedData = {};
				preparedData.searchResultToken =  data.searchResultToken;
				
				// Connect to Endpoint
				api({
					   url    : config.API_URL+'/api/v1/order/properties/search/check',
					   method : 'POST',
					   data   : preparedData,
					   headers: {
							"x-access-token": userObj?.userToken,
							Accept: 'application/json'
						}
				})							
				
				.then((response) => {

					// Document already registered
					if (!response.data?.searchExist || response.data?.noToken) {
						
						props.setAlertExpire(true);
						props.setAlertTitleExpire("O resultado da busca expirou");
						props.setAlertBodyExpire("O resultado da busca expirou. Faça uma nova pesquisa, para ver preços e hospedagens atualizados.");
						props.setAlertActionExpire("restartSearch");
						return;
						
					} // end if
					
				})
				.catch(error=> {
					logger.debug('ERRO CATCH >>>>>>>>>> '+JSON.stringify(error.message,null,2));
				});

			} catch (error) {
				logger.error('Error fetching locality search:', error);
				return;				
			}				
	
	} // end dispatch

};


export const deleteSearchResult  = (data,props) => { 
	
	return async (dispatch, getState) => {
		
		try {

				// Check if there is a local USER OBEJECt with a TOKEN
				var result = localStorage.getItem("@dream4/userData", undefined,true);
				var userObj = JSON.parse(result);  
				
							
				// Set general data
				const preparedData = {};
				preparedData.searchResultToken =  data.searchResultToken;
				preparedData.afterAction =  data.afterAction;
				
				// Connect to Endpoint
				api({
					   url    : config.API_URL+'/api/v1/order/properties/search/delete',
					   method : 'DELETE',
					   data   : preparedData,
					   headers: {
							"x-access-token": userObj?.userToken,
							Accept: 'application/json'
						}
				})							
				
				.then((response) => {

					//logger.debug('RESPONSE >>>>>> '+JSON.stringify(response.data,null,2));

					// Document already registered
					if (response.data?.notFound) {

						props.setContentLoading(false);
						props.setRestarting?.(false);

						props.setAlertExpire(true);
						props.setAlertTitleExpire("O resultado da busca expirou");
						props.setAlertBodyExpire("O resultado da busca expirou. Faça uma nova pesquisa, para ver preços e disponibilidade atualizados.");
						props.setAlertActionExpire("restartSearch");

						return;

					} // end if

					if (response.data.success) {

						dispatch(setSearchResToken(null));
						dispatch(setSearchResRowsNumber(0));
						dispatch(setSearchType("location"));

						// If reset search
						if (data.afterAction == 'reset') {
							props.navigate("/order");
						}
						// If delete and search
						else {
							props.executeProcessSearch();
						}

						return;


					} // end if
					else {

						props.setContentLoading(false);
						props.setRestarting?.(false);

						// For interface feedback
						setTimeout(function() {
						//	props.setLoadingResults(false);
						},2000);

						props.setAlertTitle("Ops! Ocorreu um erro!");
						props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [1]");
						props.setAlert(true);
						return;

					} // end else

				})
				.catch(error=> {

					props.setContentLoading(false);
					props.setRestarting?.(false);

						// For interface feedback
						setTimeout(function() {
						//	props.setLoadingResults(false);
						},2000)

					props.setAlertTitle("Ops! Ocorreu um erro!");
					props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [2]");
					props.setAlert(true);

					return;
				});

			} catch (error) {
				logger.error('Error fetching locality search:', error);
				props.setAlertTitle("Ops! Ocorreu um erro!");
				props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [3]");
				props.setAlert(true);	
				return;				
			}				
	
	} // end dispatch

};


export const processPropertySearch  = (data,props,options = {}) => {

	return async (dispatch, getState) => {

		breadcrumb('search', 'processPropertySearch start', {
			propertyId: data?.property?.code,
			source: data?.property?.source,
			rooms: data?.rooms?.length,
			days: data?.dateRangeDays,
		});

		try {

				// Check if there is a local USER OBEJECt with a TOKEN
				var result = localStorage.getItem("@dream4/userData", undefined,true);
				var userObj = JSON.parse(result);
											
				// Set general data
				const preparedData = {};
				preparedData.origin =  data.property.source;		
				preparedData.propertyId =  data.property.code;	
				preparedData.dateRange =  data.dateRange;		
				preparedData.dateRangeDays =  data.dateRangeDays;		
				preparedData.rooms =  data.rooms;							
				preparedData.searchType =  'property';	

				//logger.debug('[preparedData]--------------> '+JSON.stringify(preparedData,null,2));
				
				// set original room array to avoid obj change
				let originalRooms = [];
				for (let i = 0; i < data.rooms.length; i++) {
					let obj = {
						adults:data.rooms[i].adults,
						children:data.rooms[i].children
					}
					originalRooms.push(obj);
				}
				data.originalRooms = originalRooms;
				
				// Connect to Endpoint
				api({
					   url    : config.API_URL+'/api/v1/order/properties/search/create',
					   method : 'POST',
					   data   : preparedData,
					   signal : options.signal,
					   headers: {
							"x-access-token": userObj?.userToken,
							Accept: 'application/json'
						}
				})

				.then((response) => {

				//	logger.debug('RESPONSE >>>>>> '+JSON.stringify(response.data,null,2));

					// Document already registered
					if (response.data.notFound) {

						props.handleTimeout('cancel');

						// For interface feedback
						props.setLoadingResults(false);

						props.setAlertTitle("Nenhuma propriedade encontrada!");
						props.setAlertBody("Não encontramos nenhuma propriedade disponível com as informações fornecidas. Verifique as datas e quartos e tente novamente.");
						props.setAlert(true);

						return;

					} // end if
 
					if (response.data.success) {

						// Cancel timer
						props.handleTimeout('cancel');

						dispatch(setSearchResToken(response.data.searchResultToken));
						dispatch(setSearchResRowsNumber(response.data.searchResultRowsNumber));
						dispatch(setSearchType("property"));

						// Set search result filters for interface
						dispatch(setSearchFilters(response.data.interfaceFilters.searchFilter));

						// Set search currency for result interface
						dispatch(setSearchCurrency(response.data.currency));

						// Set exchange rates
						dispatch(setExchangeRates(response.data.exchangeRates));

						// set search location
						if (data.searchType != 'property') {
							let location = {
								continent:data.country ? data.country.continentName : null,
								country:data.country ? data.country : null,
								city:data.city ? data.city : null
							} 
							dispatch(setSearchLocation(location));
						}

						dispatch(setSearchParams(data));
						// BUG-004: primeira data reservável, calculada pelo backend. Ausente em payload
						// anterior a 14/08 — a tela trata a falta exibindo o aviso sem citar data.
						dispatch(setSearchMeta(response.data.searchMeta));

						props.setCounterStatus(true); // Stop counter

						// For interface feedback
						setTimeout(function() {
							
							props.setLoadingResults(false); 
							props.navigate(`/order/hotel/view/${response.data.hotelid_gar}`);								
													
						},1000);						
							
						return;
				
						
					} // end if
					else {
						
						// Cancel timer
						props.handleTimeout('cancel');

						// For interface feedback
						setTimeout(function() {
							props.setLoadingResults(false);
						},2000)						

						props.setAlertTitle("Ops! Ocorreu um erro!");
						props.setAlertBody("Ocorreu um erro ao realizar a busca com os dados informados. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [Order 1]");
						props.setAlert(true);																		
						return;
						
					} // end else
					
				})
				.catch(error=> {
					// Cancelamento via AbortController: ignora, NÃO toca em UI
					if (isAbortError(error)) return;

					logger.error('CATHC ERROR: Error fetching locality search:', error.message);

					// Cancel timer
					props.handleTimeout('cancel');

						// For interface feedback
						setTimeout(function() {
							props.setLoadingResults(false);
						},2000)

					props.setAlertTitle("Ops! Ocorreu um erro!");
					props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [Order 2]");
					props.setAlert(true);

					return;
				});

			} catch (error) {
				logger.error('Error fetching locality search:', error);

				// Cancel timer
				props.handleTimeout('cancel');

				dispatch(setSearchResToken(null));
				dispatch(setSearchResRowsNumber(0));

				props.setAlertTitle("Ops! Ocorreu um erro!");
				props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [Order 3]");
				props.setAlert(true);
				return;
			}

	} // end dispatch

};

export const retrieveSearchResultProperty  = (data,props) => { 
	
	return async (dispatch, getState) => {
		
		try {

				// Check if there is a local USER OBEJECt with a TOKEN
				var result = localStorage.getItem("@dream4/userData", undefined,true);
				var userObj = JSON.parse(result);  
											
				// Set general data
				const preparedData = {};
				preparedData.searchResultToken =  data.searchResultToken;
				preparedData.propertyId =  data.propertyId;
								
				// Connect to Endpoint
				api({
					   url    : config.API_URL+'/api/v1/order/properties/search/single/retrieve',
					   method : 'POST',
					   data   : preparedData,
					   headers: {
							"x-access-token": userObj?.userToken,
							Accept: 'application/json'
						}
				})						
				
				.then((response) => {

					 //logger.debug('RESPONSE >>>>>> '+JSON.stringify(response.data,null,2));

					// Document already registered
					if (response.data?.notToken) {
						
						props.setContentLoading(false);
											
						props.setAlert(true);
						props.setAlertTitle("O resultado da busca expirou");
						props.setAlertBody("O resultado da busca expirou. Faça uma nova pesquisa, para ver preços e hospedagens atualizados.");
						props.setAlertAction("restartSearch");

						return;
						
					} // end if

					// Document already registered
					if (response.data?.notFound) {
						
						props.setContentLoading(false);

						// Close the modal
						// ...
												
						props.setAlert(true);
						props.setAlertTitle("Não encontramos essa propriedade");
						props.setAlertBody("A propriedade que selecionou não foi encontrada.");
						props.setAlertAction("close");

						return;
						
					} // end if

					if (response.data.success) {
						
						props.setContentLoading(false);

						const newResults = response.data.data;
						props.setResultCard(newResults);			
							
						return;
				
						
					} // end if
					else {
						
						props.setContentLoading(false);

						props.setAlertTitle("Ops! Ocorreu um erro!");
						props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [1]");
						props.setAlert(true);																		
						return;
						
					} // end else
					
				})
				.catch(error=> {

					logger.debug('ERRO CATCH >>>>>>>>>> '+JSON.stringify(error.message,null,2));

					props.setContentLoading(false);
					
					props.setAlertTitle("Ops! Ocorreu um erro!");
					props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [2]");
					props.setAlert(true);	
							
					return;
				});

			} catch (error) {

				props.setContentLoading(false);

				logger.error('Error fetching locality search:', error);
				props.setAlertTitle("Ops! Ocorreu um erro!");
				props.setAlertBody("Ocorreu um erro ao realizar a busca. Tente novamente e caso o problema persista, entre em contato com o suporte. Erro: [3]");
				props.setAlert(true);	
				return;				
			}				
	
	} // end dispatch

};

/**
 * Gera e baixa o PDF (voucher / recibo / cotação).
 *
 * BUG-004: `bookingId` é opcional mas deve ser enviado SEMPRE que existir. Com ele o backend
 * reconstrói o payload a partir da reserva e sobrescreve os campos sensíveis — o prazo de
 * cancelamento impresso deixa de depender do que o cliente manda. O voucher é o documento que a
 * agência arquiva e no qual se baseia para agir; no incidente ele afirmava "07/07 às 23h59" (texto
 * fixo!) numa janela que fechou às 12h00.
 *
 * Também é o que permite ao BE checar que a reserva pertence a quem pediu — o endpoint não tinha
 * checagem nenhuma. Documento do tipo `quote` não tem reserva ainda: vai sem `bookingId`.
 */
export const downloadQuotePdf = (data, type='quote', bookingId=null) => {
  return async (dispatch, getState) => {
    try {

      // Pega o userData do localStorage
      var result = JSON.stringify(authStorage.getUserData() || {});
      var userData = JSON.parse(result);

      /*const response = await api.post(config.API_URL+'/order/generateHotelDocument', {
        type: 'quote',
        info: data
      }, {
        responseType: 'blob' // importante para lidar com arquivos
      });*/

      // Faz a requisição para a API
      const response = await api({
        url: config.API_URL + '/api/v1/order/generateHotelDocument',
        method: 'POST',
        data: {
			type: type,
			info: data,
			...(bookingId ? { bookingId: Number(bookingId) } : {})
      	},
        headers: {
          "x-access-token": userData?.userToken,
          Accept: 'application/json'
        },
		responseType: 'blob' // importante para lidar com arquivos
      });	  

      // Cria um link e força o download do arquivo PDF
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;

	  let downloadedFilename;
	  if (type == 'quote') {
		downloadedFilename = `cotacao-${moment().format('DD-MM-YYYY')}.pdf`;
	  } else if (type == 'receipt') {
		downloadedFilename = `confirmacao-${moment().format('DD-MM-YYYY')}.pdf`;
	  } else {
		downloadedFilename = `voucher-${moment().format('DD-MM-YYYY')}.pdf`;
	  }

      link.setAttribute('download', downloadedFilename);
      document.body.appendChild(link);
      link.click();
      link.remove();

      return { success: true };
    } catch (error) {
      logger.error('Erro ao baixar PDF da cotação', error);
      return { success: false };
    }
  };
};


export const retrievePersonInfoByDocument = (data) => {
  return async (dispatch, getState) => {
    try {
      // Pega o userData do localStorage
      var result = JSON.stringify(authStorage.getUserData() || {});
      var userData = JSON.parse(result);

      // Prepara os dados para envio
      const preparedData = {
        documentNumber: data.personDocument
      };


      // Faz a requisição para a API
      const response = await api({
        url: config.API_URL + '/api/v1/company/retrievePersondocumentInfo',
        method: 'POST',
        data: preparedData,
        headers: {
          "x-access-token": userData?.userToken,
          Accept: 'application/json'
        }
      });

      // Retorna o objeto com status e dados para ser tratado no componente
      if (response.data.success && response.data.status === 1) {
        let documentStatus = response.data.data.situacao || null;

        return {
          success: true,
          documentAlreadyUsed: response.data.documentAlreadyUsed || false,
          documentStatus,
          personData: response.data.data
        };
      } else {
        return {
          success: false,
          error: true,
          errorMessage: response.data.data?.erro || 'Erro ao buscar dados do CPF'
        };
      }
    } catch (error) {
      return {
        success: false,
        error: true,
        errorMessage: error.message
      };
    }
  };
};

export const deleteDirectSearchResult = (data) => {
  return async (dispatch, getState) => {
    try {
      // Recupera dados do usuário
      var result = JSON.stringify(authStorage.getUserData() || {});
      var userObj = JSON.parse(result);

      // Prepara os dados para envio
      const preparedData = {
        searchResultToken: data.searchResultToken
      };

      // Chama endpoint
      const response = await api({
        url: config.API_URL + '/api/v1/order/properties/search/delete',
        method: 'DELETE',
        data: preparedData,
        headers: {
          "x-access-token": userObj?.userToken,
          Accept: 'application/json'
        }
      });

      // Se resposta de not found
      if (response.data?.notFound) {
        return {
          success: false,
          notFound: true,
          message: "O resultado da busca expirou. Faça uma nova pesquisa."
        };
      }

      // Se sucesso
      if (response.data.success) {

        dispatch(setSearchResToken(null));
        dispatch(setSearchResRowsNumber(0));

        return {
          success: true
        };
      } else {
        return {
          success: false,
          error: true,
          errorMessage: response.data?.errorMessage || "Erro ao excluir o resultado da busca. Tente novamente."
        };
      }

    } catch (error) {
      return {
        success: false,
        error: true,
        errorMessage: error.message || "Erro ao excluir o resultado da busca."
      };
    }
  };
};


export const createBooking = (data, timeoutMs = 45000) => {
    return async (dispatch, getState) => {

        try {
            // Recupera o token salvo localmente
            var result = localStorage.getItem("@dream4/userData", undefined, true);
            var userObj = JSON.parse(result);

            // Prepara payload
            const preparedData = data;

            // Cria a promise do axios
            const axiosPromise = api({
                url: config.API_URL + '/api/v1/order/booking/create',
                method: 'POST',
                data: preparedData,
                headers: {
                    "x-access-token": userObj?.userToken,
                    Accept: 'application/json'
                }
            });

            // Cria a promise de timeout
            const timeoutPromise = new Promise((_, reject) => 
                setTimeout(() => reject(new Error('Tempo limite excedido. Tente novamente.')), timeoutMs)
            );

            // Corre as duas em "corrida"
            const response = await Promise.race([axiosPromise, timeoutPromise]);

            // Sucesso
            return {
                success: response.data.success,
                data: response.data
            };

        } catch (error) {
            logger.error('Erro ao criar booking:', error);
            const body = error?.response?.data || null;
            return {
                success: false,
                error: body?.errorMessage || error.message,
                // BUG-004: o BE passou a RECUSAR a criação quando a tarifa não tem janela de
                // cancelamento utilizável (409 NO_FREE_CANCELLATION_WINDOW + `reason`). Sem expor o
                // código aqui, a tela só conseguiria repetir a mensagem crua do servidor.
                code: body?.code || body?.errorCode || null,
                reason: body?.reason || null,
                status: error?.response?.status || null,
                details: body
            };
        }
    };
};

export const retrieveCompanyComission = (data) => {
  return async (dispatch, getState) => {
    try {
      // Recupera dados do usuário
      var result = JSON.stringify(authStorage.getUserData() || {});
      var userObj = JSON.parse(result);

      // Prepara os dados para envio
      const preparedData = {
        currentAgency: data.currentAgency
      };

      // Chama endpoint
      const response = await api({
        url: config.API_URL + '/api/v1/order/payment/retrieveCompanyComission',
        method: 'POST',
        data: preparedData,
        headers: {
          "x-access-token": userObj?.userToken,
          Accept: 'application/json'
        }
      });

      // Se sucesso
      if (response.data.success) {
        return {
          success: true,
		  customComission: response.data.customComission || null,
		  globalComission: response.data.globalComission || null,
        };
      } else {
        return {
          success: false,
          error: true,
          errorMessage: response.data?.errorMessage || "Erro ao buscar a comissão da agência. Tente novamente."
        };
      }

    } catch (error) {
      return {
        success: false,
        error: true,
        errorMessage: error.message || "Erro ao buscar a comissão da agência."
      };
    }
  };
};


export const retrieveExchangeRate = () => {
  return async (dispatch, getState) => {
    try {
      // Recupera dados do usuário
      var result = JSON.stringify(authStorage.getUserData() || {});
      var userObj = JSON.parse(result);

      // Chama endpoint
      const response = await api({
        url: config.API_URL + '/api/v1/order/payment/retrieveExchangeRate',
        method: 'GET',
        headers: {
          "x-access-token": userObj?.userToken,
          Accept: 'application/json'
        }
      });

      // Se sucesso
      if (response.data.success) {
        return {
          success: true,
		  exchangeRates: response.data.exchangeRates || null,
        };
      } else {
        return {
          success: false,
          error: true,
          errorMessage: response.data?.errorMessage || "Erro ao buscar a taxa de câmbio. Tente novamente."
        };
      }

    } catch (error) {
      return {
        success: false,
        error: true,
        errorMessage: error.message || "Erro ao buscar a taxa de câmbio."
      };
    }
  };
};


// Pagar a reserva (POST /api/v1/order/booking/pay)
// - Não mexe em interface (sem toasts/alerts/sets de loading).
// - Retorna { success, data } em sucesso.
// - Retorna { success:false, error, status, details } em erro.
// - Inclui corrida com timeout configurável (default: 45s).
export const payBooking = (data, timeoutMs = 45000) => {
  return async (dispatch, getState) => {
    try {
      // Recupera token salvo localmente (mesmo padrão das outras actions)
      const result = localStorage.getItem("@dream4/userData", undefined, true);
      const userObj = JSON.parse(result || '{}');

      if (!userObj?.userToken) {
        return {
          success: false,
          error: 'NO_TOKEN',
          status: 401,
          details: { message: 'User token not found in @dream4/userData.' }
        };
      }

      // Payload já vem pronto do front (respeita o contrato do endpoint)
      const preparedData = {
        customer: data?.customer,
        payment: data?.payment,
		bookingId: data?.bookingId,
		bookingVoucherInfo: data?.bookingVoucherInfo
      };

      // Promise do axios
      const axiosPromise = api({
        url: `${config.API_URL}/api/v1/order/booking/pay`,
        method: 'POST',
        data: preparedData,
        headers: {
          'x-access-token': userObj?.userToken,
          'Accept': 'application/json'
        }
      });

      // Promise de timeout
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('TIMEOUT')), timeoutMs)
      );

      // “Corrida” entre requisição e timeout
      const response = await Promise.race([axiosPromise, timeoutPromise]);

      // Sucesso: retorna objeto padronizado
      return {
        success: !!response?.data?.success,
        data: response?.data
      };

    } catch (error) {
      // Erro controlado: normalize para o componente tratar
      const status = error?.response?.status || null;
      const details = error?.response?.data || null;

      // Tente preservar mensagem vinda do backend; fallback: message da exception
      const backendMsg =
        details?.errorMessage ||
        details?.message ||
        error?.message ||
        'UNKNOWN_ERROR';

      return {
        success: false,
        error: backendMsg,
        status,
        details
      };
    }
  };
};

// Pagar multiplas reservas (POST /api/v1/order/booking/pay)
// - Retorna { success, data } em sucesso.
// - Retorna { success:false, error, status, details } em erro.
// - Inclui corrida com timeout configurável (default: 45s).
export const payMultipleBooking = (data, timeoutMs = 45000) => {
  return async (dispatch, getState) => {
    try {
      // Recupera token salvo localmente (mesmo padrão das outras actions)
      const result = localStorage.getItem("@dream4/userData", undefined, true);
      const userObj = JSON.parse(result || '{}');

      if (!userObj?.userToken) {
        return {
          success: false,
          error: 'NO_TOKEN',
          status: 401,
          details: { message: 'User token not found in @dream4/userData.' }
        };
      }

      // Payload já vem pronto do front (respeita o contrato do endpoint)
      const preparedData = {
        customer: data?.customer,
        payment: data?.payment,
		bookings: data?.bookings
      };

      // Promise do axios
      const axiosPromise = api({
        url: `${config.API_URL}/api/v1/order/booking/multiple/pay`,
        method: 'POST',
        data: preparedData,
        headers: {
          'x-access-token': userObj?.userToken,
          'Accept': 'application/json'
        }
      });

      // Promise de timeout
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('TIMEOUT')), timeoutMs)
      );

      // “Corrida” entre requisição e timeout
      const response = await Promise.race([axiosPromise, timeoutPromise]);

      // Sucesso: retorna objeto padronizado
      return {
        success: !!response?.data?.success,
        data: response?.data
      };

    } catch (error) {
      // Erro controlado: normalize para o componente tratar
      const status = error?.response?.status || null;
      const details = error?.response?.data || null;

      // Tente preservar mensagem vinda do backend; fallback: message da exception
      const backendMsg =
        details?.errorMessage ||
        details?.message ||
        error?.message ||
        'UNKNOWN_ERROR';

      return {
        success: false,
        error: backendMsg,
        status,
        details
      };
    }
  };
};

// Verifica status do pagamento 
export const verifyPaymentStatus = (data, timeoutMs = 45000) => {
  return async (dispatch, getState) => {
    try {
      // Recupera token salvo localmente (mesmo padrão das outras actions)
      const result = localStorage.getItem("@dream4/userData", undefined, true);
      const userObj = JSON.parse(result || '{}');

      if (!userObj?.userToken) {
        return {
          success: false,
          error: 'NO_TOKEN',
          status: 401,
          details: { message: 'User token not found in @dream4/userData.' }
        };
      }

      // Payload já vem pronto do front (respeita o contrato do endpoint)
      const preparedData = {
        externalId: data?.gatewayPaymentId
      };

      // Promise do axios
      const axiosPromise = api({
        url: `${config.API_URL}/api/v1/order/booking/payment/verify`,
        method: 'POST',
        data: preparedData,
        headers: {
          'x-access-token': userObj?.userToken,
          'Accept': 'application/json'
        }
      });

      // Promise de timeout
      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('TIMEOUT')), timeoutMs)
      );

      // “Corrida” entre requisição e timeout
      const response = await Promise.race([axiosPromise, timeoutPromise]);

      // Sucesso: retorna objeto padronizado
      return {
        success: !!response?.data?.success,
        data: response?.data
      };

    } catch (error) {
      // Erro controlado: normalize para o componente tratar
      const status = error?.response?.status || null;
      const details = error?.response?.data || null;

      // Tente preservar mensagem vinda do backend; fallback: message da exception
      const backendMsg =
        details?.errorMessage ||
        details?.message ||
        error?.message ||
        'UNKNOWN_ERROR';

      return {
        success: false,
        error: backendMsg,
        status,
        details
      };
    }
  };
};

      // ----------------------------
      // Helpers
      // ----------------------------
      const isPositiveInt = (v) =>
        (typeof v === 'number' && Number.isFinite(v) && v > 0) ||
        (!!v && /^\d+$/.test(String(v)) && Number(v) > 0);

		
      const FRIENDLY_BY_CODE = {
        // AUTH
        '40101': 'Sua sessão expirou. Faça login novamente.',
        '40102': 'Token inválido ou expirado. Entre novamente.',
        '40103': 'Token inválido. Entre novamente.',

        // PARAMS
        '40001': 'ID da reserva inválido. Tente novamente a partir da lista de reservas.',

        // NOT FOUND
        '40401': 'Reserva não encontrada para esta empresa.',

        // CONFLICTS
        '40901': 'A reserva não pode ser cancelada pois foi alterada enquanto visualizava a mesma. Recarregamos os dados, verifique e tente novamente.',
        '40902': 'A reserva mudou de status durante o processo. Atualize os dados e tente novamente.',
        '40903': 'Não foi possível localizar o pagamento vinculado à reserva.',

        // BUG-004 — cancelamento com custo. O BE recusa e devolve o valor da multa; quem monta a
        // mensagem é o modal, que tem o valor formatado. Precisa estar mapeado aqui mesmo assim:
        // sem isso o normalizador cai no FRIENDLY_BY_STATUS[409] e o operador leria "a reserva foi
        // alterada enquanto visualizava" no lugar do custo.
        'CANCEL_HAS_COST': 'Este cancelamento tem custo. Confirme o valor para prosseguir.',

        // PROVIDER / TRANSACTION
        '50201': 'Não foi possível confirmar o cancelamento com o fornecedor. Tente novamente em instantes.',
        '50202': 'Instabilidade ao comunicar com o fornecedor. Tente novamente.',

        // GENERAL
        '50002': 'Falha durante a transação de cancelamento.',
        '50001': 'Erro inesperado no servidor. Tente novamente.'
      };

      const FRIENDLY_BY_STATUS = {
        400: 'Dados inválidos. Verifique as informações e tente novamente.',
        401: 'Sua sessão expirou. Faça login novamente.',
        404: 'Reserva não encontrada. Recarregue a página e tente novamente.',
        409: 'A reserva não pode ser cancelada pois foi alterada enquanto visualizava a mesma. Recarregamos os dados, verifique e tente novamente.',
        500: 'Erro interno. Tente novamente em instantes.',
        502: 'Instabilidade no fornecedor. Tente novamente.'
      };


const friendlyFromBackend = (details, status) => {
	const code = details?.errorCode || details?.code || null;
	return (
		(code && FRIENDLY_BY_CODE[code]) ||
		(status && FRIENDLY_BY_STATUS[status]) ||
		details?.errorMessage ||
		details?.message ||
		'Não foi possível concluir o cancelamento no momento.'
	);
};	  

// Cancel reservation (PUT /api/v1/reservation/cancel)
// data = { bookingId: number, cancelReasonId: number, cancelReasonDescription?: string,
//          confirmCost?: boolean }
//
// BUG-004: havendo multa, o BE recusa com 409 `CANCEL_HAS_COST` e devolve `cancelCost` + `freeUntil`.
// Só prossegue quando a chamada é repetida com `confirmCost: true` — ou seja, depois que um humano
// viu o número. O reenvio é responsabilidade de quem chama (ver ReservationCancelModal).
export const cancelReservation = (data, timeoutMs = 45000) => {
  return async (_dispatch, _getState) => {
    try {
      
      // ----------------------------
      // Token
      // ----------------------------
      const result = localStorage.getItem("@dream4/userData", undefined, true);
      const userObj = JSON.parse(result || '{}');

      if (!userObj?.userToken) {
        return {
          success: false,
          errorKey: 'NO_TOKEN',
          userMessage: 'Sua sessão expirou. Faça login novamente.',
          error: 'User token not found in @dream4/userData.',
          status: 401,
          details: null
        };
        }

      // ----------------------------
      // Validações rápidas (front)
      // ----------------------------
      if (!isPositiveInt(data?.bookingId)) {
        return {
          success: false,
          errorKey: 'INVALID_PARAMS',
          userMessage: 'Selecione uma reserva válida para cancelar.',
          error: 'bookingId is required and must be a positive integer',
          status: 400,
          details: { field: 'bookingId' }
        };
      }

      if (!isPositiveInt(data?.cancelReasonId)) {
        return {
          success: false,
          errorKey: 'INVALID_PARAMS',
          userMessage: 'Selecione o motivo do cancelamento.',
          error: 'cancelReasonId is required and must be a positive integer',
          status: 400,
          details: { field: 'cancelReasonId' }
        };
      }

      const preparedData = {
        bookingId: Number(data.bookingId),
        cancelReasonId: Number(data.cancelReasonId),
        cancelReasonDescription:
          data?.cancelReasonDescription && data.cancelReasonDescription.trim().length
            ? data.cancelReasonDescription.trim()
            : 'Sem justificativa informada para cancelamento.',
        // Só vai no corpo quando é true — mandar `false` não muda nada no BE, mas deixaria a
        // confirmação de custo parecendo uma decisão tomada em toda chamada.
        ...(data?.confirmCost === true ? { confirmCost: true } : {})
      };

      // ----------------------------
      // Requisição + timeout
      // ----------------------------
      const axiosPromise = api({
        url: `${config.API_URL}/api/v1/reservation/cancel`,
        method: 'PUT',
        data: preparedData,
        headers: {
          'x-access-token': userObj?.userToken,
          'Accept': 'application/json'
        }
      });

      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('TIMEOUT')), timeoutMs)
      );

      const response = await Promise.race([axiosPromise, timeoutPromise]);

      // ----------------------------
      // Sucesso
      // ----------------------------
      return {
        success: !!response?.data?.success,
        data: response?.data
      };

    } catch (error) {
      // ----------------------------
      // Erros normalizados
      // ----------------------------
      // Timeout explícito
      if (error?.message === 'TIMEOUT') {
        return {
          success: false,
          errorKey: 'TIMEOUT',
          userMessage: 'Tempo esgotado ao cancelar a reserva. Tente novamente e se persistir o problema, entre em contato com o suporte.',
          error: 'TIMEOUT',
          status: null,
          details: null
        };
      }

      // Erro de rede (sem response)
      if (!error?.response) {
        return {
          success: false,
          errorKey: 'NETWORK_ERROR',
          userMessage: 'Não foi possível conectar ao servidor. Verifique sua conexão e tente novamente.',
          error: error?.message || 'NETWORK_ERROR',
          status: null,
          details: null
        };
      }

      // Erro com response do backend
      const status = error.response.status || null;
      const details = error.response.data || null;

      // friendly message baseado em errorCode/status/message do backend
      const userMessage = friendlyFromBackend(details, status);

      // Mantém também uma mensagem técnica para logs/telemetria
      const technical =
        details?.errorMessage ||
        details?.message ||
        error?.message ||
        'UNKNOWN_ERROR';

      return {
        success: false,
        errorKey: details?.errorCode || details?.code || null,
        userMessage,
        error: technical,
        status,
        details
      };
    }
  };
};

// Recupera múltiplas reservas para pagamento em lote
// data = { bookingIds: number[] }
// Retorno: { success: true, data: { reservations, totals, ... } } | { success:false, error, status, details }
export const retrieveMultipleReservations = (data, timeoutMs = 45000) => {
  return async (_dispatch, _getState) => {
    try {
      // Token (padrão do projeto)
      const result  = localStorage.getItem("@dream4/userData", undefined, true);
      const userObj = JSON.parse(result || '{}');

      if (!userObj?.userToken) {
        return {
          success: false,
          error: 'NO_TOKEN',
          status: 401,
          details: { message: 'User token not found in @dream4/userData.' }
        };
      }

      const bookingIds = Array.isArray(data?.bookingIds) ? data.bookingIds.slice(0, 10) : [];
      if (bookingIds.length === 0) {
        return {
          success: false,
          error: 'INVALID_PARAMS',
          status: 400,
          details: { message: "Send 'bookingIds' as a non-empty array." }
        };
      }

      const axiosPromise = api({
        url: `${config.API_URL}/api/v1/reservation/multiples/retrieve`,
        method: 'POST',
        data: { bookingIds },
        headers: {
          'x-access-token': userObj?.userToken,
          'Accept': 'application/json'
        }
      });

      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('TIMEOUT')), timeoutMs)
      );

      const response = await Promise.race([axiosPromise, timeoutPromise]);

      return {
        success: !!response?.data?.success,
        data: response?.data
      };

    } catch (error) {
      const status  = error?.response?.status || null;
      const details = error?.response?.data || null;

      const backendMsg =
        details?.errorMessage ||
        details?.message ||
        error?.message ||
        'UNKNOWN_ERROR';

      return {
        success: false,
        error: backendMsg,
        status,
        details
      };
    }
  };
};